import React from 'react';
import { message, Space, Card, Row, Col, Input, Steps, Button, Divider, Checkbox, Form, Result, Upload, Tooltip, Progress } from 'antd';
import CreatePage from './CreatePage';
import { useAuth } from 'authentication';
import { httpClient, uploadClient } from 'util/Api';
import * as globalFunction from 'util/GlobalFunction';
import AppNotificationContainer from 'components/AppNotificationContainer';
import AntDraggableModal from 'components/AntDraggableModal';
import { config } from 'util/config';
import { useHistory } from "react-router-dom";
import * as imageConversion from 'image-conversion';
import moment from 'moment';
import ReCAPTCHA from "react-google-recaptcha";

const PublicLodge = () => {
  const { authUser, setAuthUser } = useAuth();
  const areaName = "Business";
  const pageName = "PublicLodge";
  const history = useHistory();

  let pathname = window.location.pathname.split('/');
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  //以React.FC为页面入口获取当前用户信息，创建React.Component页面
  return (
    <PublicLodgePage authUser={authUser} setAuthUser={setAuthUser} areaName={areaName} pageName={pageName} urlParams={urlParams} setting={pathname[pathname.length - 1]} history={history} />
  )
}
export default PublicLodge;

class PublicLodgePage extends React.Component {
  constructor(props) {
    super();
    this.state = {
      searchParameter: {
        setting: props.setting
      },
      defaultFormData: {
        setting: props.setting
      },
      module: '',
      jobId: 0,
      moduleId: 0,
      state: '',
      formData: {},
      loaded: false,
      loading: true,
      jobData: {},
      sectionData: [],
      page: null,
      webUIConfig: null,
      allWebUIConfig: null,
      companyId: 0,
      fileList: [],
      fileUploadLimit: 20,
      submitSuccess: false,
      recaptchaShow: false,
      allPublicHoliday: [],
      publicHoliday: [],
      cutoffHours: 16,
      cutoffMinutes: 0,
      defaultState: null,
      successfulMessage: undefined,
      tracking: null,
      searchAddressType: '',
      submitDisable: false
    }

    this.formRef = React.createRef();
    this.createPage = React.createRef();
    this.recaptchaRef = React.createRef();
  }

  //查询该Job的module
  componentDidMount() {
    let tracking = this.props.urlParams.get('tracking');
    this.setState({ tracking });

    this.getWebUI();
  }

  getPublicHoliday() {
    let that = this;
    httpClient
      .get('/System/PublicHoliday/GetPublicList')
      .then(({ data }) => {
        if (data.result) {
          let allPublicHoliday = data.data;
          let publicHoliday = allPublicHoliday.map(item => globalFunction.formatDate(item.Date))
          this.setState({ allPublicHoliday, publicHoliday });
        } else {
          message.error(data.message);
        }
      })
      .catch(function (error) {
        message.error('Error');
      });
  }

  getSubJobBlockDates() {
    let that = this;
    httpClient
      .get('/Admin/SubJobBlockDates/GetPublicList?companyId=' + this.state.companyId + '&moduleId=' + this.state.moduleId)
      .then(({ data }) => {
        if (data.result) {
          this.setState({ publicHoliday: data.data.map(item => globalFunction.formatDate(item.Date)) });
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  getWebUI() {
    let that = this;
    httpClient
      .get('/System/WebUI/GetPublicLodgeWebUI?setting=' + this.props.setting)
      .then(({ data }) => {
        if (data.result) {
          let publicLodgeWebUI = data.data;
          const decodedString = atob(publicLodgeWebUI.webUIConfig);
          publicLodgeWebUI.webUIConfig = JSON.parse(decodedString);

          let successfulMessage = publicLodgeWebUI.webUIConfig.sectionList[0].componentList.filter(c => c.type === 'SuccessfulMessage')[0];
          document.title = publicLodgeWebUI.webUIConfig.sectionList[0].componentList.filter(c => c.type === 'View')[0].title;
          this.setState({ webUIConfig: publicLodgeWebUI.webUIConfig, allWebUIConfig: publicLodgeWebUI.webUIConfig, companyId: publicLodgeWebUI.CompanyId, moduleId: publicLodgeWebUI.ModuleId, cutoffHours: publicLodgeWebUI.CutoffHours, cutoffMinutes: publicLodgeWebUI.CutoffMinutes, defaultState: publicLodgeWebUI.ModuleConfig.DefaultState, successfulMessage, loaded: true, loading: false });
          switch (publicLodgeWebUI.ModuleConfig.SubJobDefaultTimeBlock) {
            case "AM":
              this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 0);
              break;
            case "PM":
              this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 1);
              break;
            case "Anytime":
              this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 2);
              break;
            case "Time Block":
              this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 3);
              break;
            default:
              this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 0);
              break;
          }
          this.formRef.current?.setFieldsValue({ ScheduledTime: [moment('06:00', 'HH:mm'), moment('12:00', 'HH:mm')], PptState: publicLodgeWebUI.ModuleConfig.DefaultState });
          this.loadCSS();
          setTimeout(() => {
            if (this.state.webUIConfig.condition === 'InspectionBooking' || this.state.webUIConfig.condition === 'PermitVariation' || this.state.webUIConfig.condition === 'OPApplication') {
              this.setState({ submitDisable: true });
            }
            this.getSubJobBlockDates();
            this.getLgaDataSource({ parameter: publicLodgeWebUI.ModuleConfig.DefaultState, lgaKeyName: null })
          }, config.setTimeoutMilliSecond);
        } else {
          this.setState({ loading: false });
          message.error(data.message);
        }
      })
      .catch(function (error) {
        that.setState({ loading: false });
        message.error('Error');
      });
  }

  loadCSS() {
    let date = new Date().getTime()
    const cssUrl = `/assets/styles/company-css/${this.state.companyId}.css?v=` + date;
    const style = document.createElement("link");
    style.href = cssUrl;
    style.rel = "stylesheet";
    style.type = "text/css";
    document.head.appendChild(style);
  }

  componentWillUnmount() {
    // 卸载已加载的CSS文件
    const cssUrl = `/assets/styles/company-css/${this.state.companyId}.css`;
    const links = document.head.getElementsByTagName("link");
    for (let i = 0; i < links.length; i++) {
      if (links[i].href === cssUrl) {
        document.head.removeChild(links[i]);
      }
    }
  }

  onRecaptchaChange = (value) => {
    this.setState({ recaptchaShow: false });
    this.sendForm(value);
  };

  sendForm(recaptcha) {
    let form = this.state.formData;
    this.setState({ submitting: true });
    this.state.page.sectionList[0].componentList[0].groupList.filter(c => c.show).forEach(group => {
      group.uieList.forEach(uie => {
        if (uie.component === 'DatePicker') {
          if (form[uie.source] !== undefined && form[uie.source] !== null) {
            form[uie.source] = moment(form[uie.source]).format(config.format.sqlDate);
          } else {
            form[uie.source] = null;
          }
        }
        if (uie.component === 'TimePicker') {
          if (form[uie.source] !== undefined && form[uie.source] !== null) {
            switch (uie.type) {
              case 'RangePicker':
                if (form[uie.source][0] !== undefined && form[uie.source][0] !== null && form[uie.source][1] !== undefined && form[uie.source][1] !== null) {
                  let time = moment(form[uie.source][0]).format('HH:mm') + ',' + moment(form[uie.source][1]).format('HH:mm');
                  form[uie.source] = time;
                } else {
                  form[uie.source] = null;
                }
                break;
              default:
                form[uie.source] = moment(form[uie.source]).format('HH:mm');
                break;
            }
          } else {
            form[uie.source] = null;
          }
        }
      });
    });

    //处理一些特殊的自定义字段
    form.Condition = this.state.webUIConfig.condition;
    form.JobId = this.state.jobId;
    form.CompanyId = this.state.companyId;
    form.ModuleId = this.state.moduleId;
    form.Recaptcha = recaptcha;
    form.PublodgePageSource = this.state.tracking;

    this.recaptchaRef.current?.reset();

    let that = this;
    httpClient
      .post('/Business/PublicLodge/CreatePublicLodge', form)
      .then(({ data }) => {
        console.log(data);
        if (data.result) {
          this.setState({ jobData: data.data });
          if (this.state.fileList.length > 0) {
            this.uploadDocumentSubmit();
          } else {
            this.setState({ submitting: false, submitSuccess: true });
          }
        } else {
          message.error(data.message);
          this.setState({ submitting: false });
        }
      })
      .catch(function (error) {
        message.error('Error');
        that.setState({ submitting: false });
      });
  }

  //提交表单
  onFinish = async (values: any) => {
    if (values.ConditionCheck == false) {
      message.info('Please tick to confirm you have read and understand the conditions.');
    } else {
      this.setState({ recaptchaShow: true, formData: values });
    }
  };

  //提交表单之前验证失败
  onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };


  //删除文件
  removeFile(file) {
    const index = this.state.fileList.indexOf(file);
    const newFileList = this.state.fileList.slice();
    newFileList.splice(index, 1);
    this.setState({ fileList: newFileList });
  }

  //上传文档
  async uploadDocumentSubmit() {
    if (this.state.fileList.length > 0) {
      this.setState({ submitting: true });
      const res = this.state.fileList.map(async (file) => {
        if (file.status === undefined) {
          let formData = new FormData();
          formData.append('jobId', this.state.jobData.JobId);

          let currentFile = file;
          if (config.imageTypes.indexOf(file.type) >= 0 && file.size > 1024 * config.uploadImageMaxLength) {
            currentFile = await imageConversion.compressAccurately(file, {
              size: config.uploadImageMaxLength,
              accuracy: '',
              type: '',
              width: '',
              height: '',
              scale: '1',
              orientation: ''
            });
            currentFile.name = file.name;
          }
          formData.append('files[]', currentFile);
          formData.append('Name', file.name);

          let that = this;
          await uploadClient
            .post('/Business/PublicLodge/PublicUpload', formData, {
              onUploadProgress: (progressEvent) => {
                const uploadProgress = (progressEvent.loaded / progressEvent.total) * 100;
                let fileList = this.state.fileList.map((oldFile, i) => {
                  if (oldFile.name === file.name && oldFile.size === file.size) {
                    oldFile.percent = uploadProgress;
                    if (oldFile.percent == 100) {
                      oldFile.status = 'done';
                    } else {
                      oldFile.status = 'uploading';
                    }
                  }
                  return oldFile;
                })
                this.setState({ fileList });
              },
            })
            .then(({ data }) => {
              if (data.result) {
                return true;
              } else {
                let fileList = that.state.fileList.map((oldFile, i) => {
                  if (oldFile.name === file.name && oldFile.size === file.size) {
                    oldFile.status = 'error';
                  }
                  return oldFile;
                })
                this.setState({ fileList });
                message.error(file.name + ' not upload, ' + data.message);
              }
            })
            .catch(function (error) {
              let fileList = that.state.fileList.map((oldFile, i) => {
                if (oldFile.name === file.name && oldFile.size === file.size) {
                  oldFile.status = 'error';
                }
                return oldFile;
              })
              that.setState({ fileList });
              message.error(file.name + ' not upload, ' + error.message);
            });
        }
      })
      await Promise.all(res);
      this.setState({ submitting: false, submitSuccess: true });

    } else {
      this.closeUploadModal();
    }
  }

  //通过输入获取可选地址列表
  searchAddressFromPredictive(value, control) {
    console.log(control);
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      //最小3个字符API才起效
      let that = this;
      if (value.trim().length >= 3) {
        httpClient
          .get('/System/SearchAddress/Predictive?str=' + value + '&state=' + this.state.defaultState + '&number=8')
          .then(({ data }) => {
            let addressData = JSON.parse(data.data);

            if (addressData.suggest.length > 0) {
              let addressList = [];
              addressData.suggest.map((item, i) => {
                let address = item.address.replace(new RegExp(value.toUpperCase(), 'g'), '<b>' + value.toUpperCase() + '</b>');
                addressList.push({ label: <span key={i} dangerouslySetInnerHTML={{ __html: address }} />, value: item.address, id: item.id, key: item.id });
              })
              this.setState({ address: value });

              let componentDataSource = this.createPage.current?.child[0].current?.state.componentDataSource;
              if (control === undefined) {
                componentDataSource.JobSearchAddress = addressList;
              } else {
                componentDataSource[control] = addressList;
              }
              this.createPage.current?.child[0].current?.setState({ componentDataSource });

            } else {
              addressData.messages.map(msg => {
                this.setState({ address: value });
              });
              let componentDataSource = this.createPage.current?.child[0].current?.state.componentDataSource;
              componentDataSource.JobSearchAddress = [];
              this.createPage.current?.child[0].current?.setState({ componentDataSource });
            }
          })
          .catch(function (error) { });
      } else {
        this.setState({ address: value });
      }

    }, 500); // 在这里设置等待的时间，500 毫
  }

  //获取地址实际数据
  getAddressData(option, control) {
    let that = this;
    httpClient
      .get('/System/SearchAddress/Addresses?id=' + option.id)
      .then(({ data }) => {
        if (data.result) {
          let addressData = JSON.parse(data.data);

          let planNo = '';
          let lotNo = '';
          if (addressData.properties.cadastralIdentifier !== null && addressData.properties.cadastralIdentifier !== undefined) {
            let stateTerritory = addressData.properties.stateTerritory.toUpperCase();
            let lp = addressData.properties.cadastralIdentifier.split('~');
            let lpdata;
            if (lp[0].indexOf('\\') > 0) {
              lpdata = lp[0].split('\\');
            } else {
              lpdata = lp[0].split('/');
            }

            if (stateTerritory === 'ACT') {
              if (lpdata.length >= 2 && (/^\d+$/.test(lpdata[lpdata.length - 1]) && /^\d+$/.test(lpdata[lpdata.length - 2]))) {
                planNo = lpdata[lpdata.length - 2];
                lotNo = lpdata[lpdata.length - 1];
              }
            } else {
              lotNo = lpdata[0];
              if (stateTerritory !== 'NSW') {
                planNo = lpdata[1];
              } else {
                let planNoArray = [];
                if (lpdata.length > 1 && lpdata[1] !== '') {
                  planNoArray.push(lpdata[1]);
                }
                if (lpdata.length > 2 && lpdata[2] !== '') {
                  planNoArray.push(lpdata[2]);
                }
                planNo = planNoArray.join('/');
              }
              if (stateTerritory === 'TAS') {
                let temp = planNo;
                planNo = lotNo;
                lotNo = temp;
              }
            }
          }

          switch (control) {
            case 'Agent':
            case 'Owner':
            case 'Builder':
              this.formRef.current?.setFieldValue(control + '_StreetNumber', addressData.properties.streetNumber1);
              if (addressData.properties.streetTypeDescription !== null && addressData.properties.streetTypeDescription !== undefined) {
                this.formRef.current?.setFieldValue(control + '_StreetName', globalFunction.titleCase(addressData.properties.streetName + ' ' + addressData.properties.streetTypeDescription).trim());
              } else {
                this.formRef.current?.setFieldValue(control + '_StreetName', globalFunction.titleCase(addressData.properties.streetName).trim());
              }
              this.formRef.current?.setFieldValue(control + '_Suburb', globalFunction.titleCase(addressData.properties.localityName));
              this.formRef.current?.setFieldValue(control + '_State', addressData.properties.stateTerritory);
              this.formRef.current?.setFieldValue(control + '_Postcode', addressData.properties.postcode);
              break;

            default:
              this.formRef.current?.setFieldValue('PptLpps', planNo);
              this.formRef.current?.setFieldValue('PptLot', lotNo);
              this.formRef.current?.setFieldValue('PptStreetNumber', addressData.properties.streetNumber1);
              if (addressData.properties.streetTypeDescription !== null && addressData.properties.streetTypeDescription !== undefined) {
                this.formRef.current?.setFieldValue('PptStreetName', globalFunction.titleCase(addressData.properties.streetName + ' ' + addressData.properties.streetTypeDescription).trim());
              } else {
                this.formRef.current?.setFieldValue('PptStreetName', globalFunction.titleCase(addressData.properties.streetName).trim());
              }
              this.formRef.current?.setFieldValue('PptSuburb', globalFunction.titleCase(addressData.properties.localityName));
              this.formRef.current?.setFieldValue('PptState', addressData.properties.stateTerritory);
              this.formRef.current?.setFieldValue('PptPostcode', addressData.properties.postcode);
              this.formRef.current?.setFieldValue('Longitude', addressData.geometry.coordinates[0]);
              this.formRef.current?.setFieldValue('Latitude', addressData.geometry.coordinates[1]);
              let lgaKeyName = addressData.properties.localGovernmentArea.lgaShortName;

              // let publicHoliday = this.state.allPublicHoliday.filter(item => item.State === addressData.properties.stateTerritory || item.State === null).map(item => globalFunction.formatDate(item.Date));
              // this.setState({ publicHoliday });
              setTimeout(() => {
                this.getLgaDataSource({ parameter: this.formRef.current?.getFieldValue('PptState'), lgaKeyName })
              }, config.setTimeoutMilliSecond);
              break;
          }
        } else {
          message.error(data.message);
        }
      })
      .catch(function (error) {
        message.error('Error');
      });
  }

  getLgaDataSource({ parameter, lgaKeyName } = {}) {
    if (parameter != undefined || (lgaKeyName !== null && lgaKeyName !== undefined)) {
      let that = this;
      httpClient
        .get('Admin/Lga/GetPublicLodgeSelectOptionList?state=' + parameter + '&companyId=' + this.state.companyId + '&moduleId=' + this.state.moduleId)
        .then(({ data }) => {
          if (data.result) {
            if (data.data.length > 0) {
              let componentDataSource = this.createPage.current?.child[0].current?.state.componentDataSource;
              componentDataSource.LgaId = data.data;
              this.createPage.current?.child[0].current?.setState({ componentDataSource });
              if (data.data.map(item => { return item.Value }).indexOf(this.formRef.current?.getFieldValue('LgaId')) < 0) {
                this.formRef.current?.setFieldsValue({ LgaId: 0 });
              } else if (lgaKeyName !== null && lgaKeyName !== undefined) {
                let lag = data.data.find(item => item.Data === lgaKeyName);
                if (lag) {
                  this.formRef.current?.setFieldsValue({ LgaId: lag.Value });
                } else {
                  this.formRef.current?.setFieldsValue({ LgaId: 0 });
                }
              }
            }
          } else {
            message.error(data.message);
          }
        })
        .catch(function (error) {
          message.error('Error');
        });
    }
  }

  //通过输入获取可选地址列表(从HyperFlo现有job)
  searchAddressFromHyperFlo(value) {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    this.timer = setTimeout(() => {
      //最小3个字符API才起效
      let that = this;
      if (value.trim().length >= 3) {
        httpClient
          .get('/System/SearchAddress/FromHyperFlo?str=' + value + '&companyId=' + this.state.companyId + '&moduleId=' + this.state.moduleId)
          .then(({ data }) => {
            let jobs = data.data;
            if (jobs.length > 0) {
              let addressList = [];
              jobs.map((item, i) => {
                let address = item.PptAddress.replace(new RegExp(value.toUpperCase(), 'g'), '<b>' + value.toUpperCase() + '</b>');
                addressList.push({ label: <span key={i} dangerouslySetInnerHTML={{ __html: address }} />, value: item.PptAddress, data: item, key: item.JobId });
              })
              this.setState({ address: value });

              let componentDataSource = this.createPage.current?.child[0].current?.state.componentDataSource;
              componentDataSource.SearchAddressFromHyperFlo = addressList;
              this.createPage.current?.child[0].current?.setState({ componentDataSource });
            } else {
              let componentDataSource = this.createPage.current?.child[0].current?.state.componentDataSource;
              componentDataSource.SearchAddressFromHyperFlo = [];
              this.createPage.current?.child[0].current?.setState({ componentDataSource });
            }
          })
          .catch(function (error) { });
      } else {
        this.setState({ address: value });
      }

    }, 500); // 在这里设置等待的时间，500 毫
  }

  //选择HyperFlo现有job的Address后填充Label
  selectAddressFromHyperFlo(option) {
    this.createPage.current?.child[0].current?.child.current?.setState({ formData: option.data });
    // let publicHoliday = this.state.allPublicHoliday.filter(item => item.State === option.data.PptState || item.State === null).map(item => globalFunction.formatDate(item.Date));
    // this.setState({ publicHoliday, jobId: option.data.JobId });
    this.setState({ jobId: option.data.JobId, submitDisable: false });
  }

  //自动填充Inspection Name
  inspectionNameOnChange({ sectionName, parameter, sectionComponent, pageComponent, uie }) {
    if (!uie.autoDataSource && uie.datasourceUrl !== null) {
      httpClient
        .get(uie.datasourceUrl + '?keyword=' + parameter + '&companyId=' + pageComponent.state.companyId + '&moduleId=' + pageComponent.state.moduleId)
        .then(({ data }) => {
          let options = [];
          if (data.result) {
            data.data.map((subJobType, j) => {
              options.push({ label: subJobType.Name, value: subJobType.Name, data: subJobType });
            })
            let componentDataSource = this.createPage.current?.child[0].current?.state.componentDataSource;
            componentDataSource.SubJobName = options;
            this.createPage.current?.child[0].current?.setState({ componentDataSource });
          } else {
            message.error(data.message);
          }
        })
        .catch(function (error) {
          message.error('Error');
        });
    } else {
      let componentDataSource = this.createPage.current?.child[0].current?.state.componentDataSource;
      componentDataSource.SubJobName = [];
      this.createPage.current?.child[0].current?.setState({ componentDataSource });
    }
  }

  scheduledTimeAmPmOnChange(option) {
    switch (option) {
      case 0:
        this.formRef.current?.setFieldValue('ScheduledTime', [moment('06:00', 'HH:mm'), moment('12:00', 'HH:mm')]);
        break;
      case 1:
        this.formRef.current?.setFieldValue('ScheduledTime', [moment('12:00', 'HH:mm'), moment('18:00', 'HH:mm')]);
        break;
      case 2:
        this.formRef.current?.setFieldValue('ScheduledTime', [moment('06:00', 'HH:mm'), moment('18:00', 'HH:mm')]);
        break;
      case 3:
        this.formRef.current?.setFieldValue('ScheduledTime', undefined);
        break;
    }
  }

  render() {
    return (
      <div>
        {
          this.state.loaded ?
            <div style={{ padding: '20px' }}>
              <div
                className='public-lodge-div ant-modal-body upload-drag-div'
                style={{ maxHeight: 'none', marginBottom: '20px' }}
                onDragOver={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();


                  let files = e.dataTransfer.files;
                  let fileList = this.state.fileList;
                  let date = new Date().getTime();
                  const filesArray = Array.from(files);

                  setTimeout(() => {
                    filesArray.map((file, i) => {
                      let have = false;
                      fileList.map((oldFile, j) => {
                        if (oldFile.name === file.name && oldFile.size === file.size) {
                          have = true;
                        }
                      })
                      if (!have) {
                        file.uid = 'rc-upload-' + date + '-' + i;
                        if (file.size / 1024 / 1024 > this.state.fileUploadLimit) {
                          file.status = 'error';
                          file.tip = file.name + ' size larger than ' + this.state.fileUploadLimit + 'M';
                        }
                        if (file.size === 0) {
                          file.status = 'error';
                          file.tip = file.name + ' - This file is 0KB and will not be uploaded. Make sure not to select or drag files from a zipped file/folder.';
                        }
                        fileList.push(file);
                      }
                    })
                    this.setState({ fileList });
                  }, config.setTimeoutMilliSecond * 2);

                }}
              >
                <div className='mb-3' dangerouslySetInnerHTML={{ __html: this.state.webUIConfig.header }}>
                </div>
                <Form
                  ref={this.formRef}
                  autoComplete="off"
                  onFinish={this.onFinish}
                  onFinishFailed={this.onFinishFailed}
                  initialValues={this.state.initialValues}
                  size={config.component.size}
                >
                  <CreatePage
                    {...this.props}
                    ref={this.createPage}
                    module={this.state.module}
                    moduleId={this.state.moduleId}
                    state={this.state.state}
                    searchParameter={this.state.searchParameter}
                    defaultFormData={this.state.defaultFormData}
                    companyId={this.state.companyId}
                    objId={this.state.jobData.JobId}
                    jobId={this.state.jobData.JobId}
                    setting={this.state.jobData.Setting}
                    uploadUrl={'/Business/Document/PublicUpload'}
                    webUIConfig={this.state.webUIConfig}
                    pageComponent={this} />

                  <div className='data-table-div'>
                    <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                      <Row gutter={config.component.gutter}>
                        <Divider orientation="left">Upload Files</Divider>
                        <Col span={24}>
                          <Upload
                            name="file"
                            style={{ width: '100%' }}
                            multiple={true}
                            fileList={this.state.fileList}
                            onRemove={(file) => {
                              this.removeFile(file);
                            }}
                            beforeUpload={(file) => {
                              let fileList = this.state.fileList;
                              if (file.size / 1024 / 1024 > this.state.fileUploadLimit) {
                                file.status = 'error';
                                file.tip = file.name + ' size larger than ' + this.state.fileUploadLimit + 'M';
                              }
                              if (file.size === 0) {
                                file.status = 'error';
                                file.tip = file.name + ' - This file is 0KB and will not be uploaded. Make sure not to select or drag files from a zipped file/folder.';
                              }
                              fileList.push(file);
                              this.setState({ fileList });
                              return false;
                            }}
                            itemRender={(originNode, file, currFileList) => (
                              <span>{
                                file.status !== 'error' ?
                                  <div className='upload-container'>
                                    <div className="ant-upload-list-item-info">
                                      <span className="ant-upload-span" style={{ marginBottom: '4px' }}>
                                        <span className="ant-upload-list-item-name" title={file.name}>{file.name} ({globalFunction.formatFileSize(file.size)})</span>
                                        <span className="ant-upload-list-item-card-actions">
                                          <Tooltip title="Delete">
                                            <Button
                                              className="upload-delete-icon"
                                              icon={<img className="svg-img-btn" src={'assets/images/icon/delete.svg'} />}
                                              type='link'
                                              onClick={() => {
                                                this.removeFile(file);
                                              }}
                                            />
                                          </Tooltip >
                                        </span>
                                      </span>
                                    </div>
                                    <div className="ant-upload-list-item-progress">
                                      <div className="ant-progress ant-progress-line ant-progress-status-normal ant-progress-show-info ant-progress-default">
                                        <Progress percent={globalFunction.formatPercent(file.percent)} strokeWidth={3} />
                                      </div>
                                    </div>
                                  </div>
                                  :
                                  <div className='upload-container'>
                                    <div className="ant-upload-list-item-info">
                                      <span className="ant-upload-span" style={{ marginBottom: '4px' }}>
                                        <span className="ant-upload-list-item-name ant-upload-list-item-error" title={file.tip}>{file.tip}</span>
                                        <span className="ant-upload-list-item-card-actions">
                                          <Tooltip title="Delete">
                                            <Button
                                              style={{ color: '#f5222d' }}
                                              className="upload-delete-icon"
                                              icon={<img className="svg-img-btn" src={'assets/images/icon/delete.svg'} />}
                                              type='link'
                                              onClick={() => {
                                                this.removeFile(file);
                                              }}
                                            />
                                          </Tooltip >
                                        </span>
                                      </span>
                                    </div>
                                  </div>
                              }</span>
                            )}
                          >
                            <span>Drag and Drop or <span className='link'>select file</span> to upload, {this.state.fileUploadLimit}MB size limit for each file and maximum 20 files. Photos will be resized to {config.uploadImageMaxLength}KB.</span>
                          </Upload>
                        </Col>
                      </Row>
                    </div>
                  </div>

                  <div>
                    <Button style={{ marginTop: '40px', width: '100%', height: '40px', lineHeight: '40px' }} key="submit" type="primary" disabled={this.state.submitDisable} loading={this.state.submitting} onClick={() => {
                      this.formRef.current?.submit();
                    }}>Submit</Button>
                  </div>
                </Form>
              </div>
              <AntDraggableModal
                title="Verification"
                open={this.state.recaptchaShow}
                onCancel={() => {
                  this.setState({ recaptchaShow: false });
                }}
                width={320}
                maskClosable={false}
                footer={[
                  <Button key="close" type="primary" onClick={() => {
                    this.setState({ recaptchaShow: false });
                  }}>
                    Close
                  </Button>
                ]}
              >
                <Row>
                  <Col span={24}>
                    Please click the checkbox below to submit
                  </Col>
                  <Col span={24} style={{ marginTop: '10px' }}>
                    <div
                      style={{ margin: 'auto', width: '160px' }}
                    >
                      <ReCAPTCHA
                        ref={this.recaptchaRef}
                        sitekey={config.recaptchaSitekey}
                        onChange={this.onRecaptchaChange}
                        size="compact"
                        theme="light"
                      />
                    </div>
                  </Col>
                </Row>
              </AntDraggableModal>
              <AntDraggableModal
                title={this.state.successfulMessage !== undefined ? <span>{this.state.successfulMessage?.title}</span> : <span>{this.state.webUIConfig.condition} Request Received</span>}
                open={this.state.submitSuccess}
                onCancel={() => {
                  this.setState({ submitting: false, submitSuccess: false, fileList: [] });
                  this.formRef.current?.resetFields();
                  this.formRef.current?.setFieldValue('LgaId', 0);
                  this.formRef.current?.setFieldValue('PptPropertyTypeId', 0);
                  this.formRef.current?.setFieldValue('PptBuildingUseOptionId', 0);
                  this.formRef.current?.setFieldValue('PptState', this.state.defaultState);
                  this.createPage.current?.child[0].current?.child.current?.setState({ formData: [] });
                  if (this.state.webUIConfig.condition === 'InspectionBooking' || this.state.webUIConfig.condition === 'PermitVariation' || this.state.webUIConfig.condition === 'OPApplication') {
                    this.setState({ submitDisable: true });
                  }
                  setTimeout(() => {
                    this.getLgaDataSource({ parameter: this.state.defaultState, lgaKeyName: null })
                  }, config.setTimeoutMilliSecond);
                }}
                width={500}
                maskClosable={false}
                footer={[
                  <Button key="submit" type="primary" onClick={() => {
                    this.setState({ submitting: false, submitSuccess: false, fileList: [] });
                    this.formRef.current?.resetFields();
                    this.formRef.current?.setFieldValue('LgaId', 0);
                    this.formRef.current?.setFieldValue('PptPropertyTypeId', 0);
                    this.formRef.current?.setFieldValue('PptBuildingUseOptionId', 0);
                    this.formRef.current?.setFieldValue('PptState', this.state.defaultState);
                    this.createPage.current?.child[0].current?.child.current?.setState({ formData: [] });
                    if (this.state.webUIConfig.condition === 'InspectionBooking' || this.state.webUIConfig.condition === 'PermitVariation' || this.state.webUIConfig.condition === 'OPApplication') {
                      this.setState({ submitDisable: true });
                    }
                    setTimeout(() => {
                      this.getLgaDataSource({ parameter: this.state.defaultState, lgaKeyName: null })
                    }, config.setTimeoutMilliSecond);
                  }}>
                    OK
                  </Button>
                ]}
              >
                <Row>
                  <Col span={4}>
                    <img src={'assets/images/successfully.png'} />
                  </Col>
                  <Col span={20}>
                    {
                      this.state.successfulMessage !== undefined ? <div dangerouslySetInnerHTML={{ __html: this.state.successfulMessage?.message }}></div> : <p>Your request has been submitted successfully!</p>
                    }
                  </Col>
                </Row>
              </AntDraggableModal>
            </div>
            :
            <AppNotificationContainer loading={this.state.loading} error={''} />
        }
      </div>
    );
  }
};
